import { tns } from 'tiny-slider/src/tiny-slider';

export const initApp = () => {
	document.addEventListener('DOMContentLoaded', function () {
		let isCloseButtonClicked = false; // Move the variable definition here
		const allowedHashes = new Set(['telephone', 'offer', 'freetrial', 'quickorder', 'thank-you']);
		let activeTabId; // Variable to store the active tabId

		// Smooth scroll function
		const scrollToTop = (element) => {
			if (!element) {
				console.error('Invalid element passed to scrollToTop function');
				return;
			}
			if (typeof element === 'string') {
				element = document.querySelector(element);
				if (!element) {
					console.error(`Element with selector '${element}' not found`);
					return;
				}
			}
			if (element instanceof HTMLElement) {
				if (!element.id) {
					console.warn('The element does not have an ID.');
				}
				element.scrollIntoView({
					behavior: 'smooth',
					block: 'start',
				});
			} else {
				console.error('Invalid element passed to scrollToTop function element ID= ' + +element.id);
			}
		};

		// Debounce function
		const debounce = (func, delay) => {
			let timeoutId;
			return function (...args) {
				clearTimeout(timeoutId);
				timeoutId = setTimeout(() => {
					func.apply(this, args);
				}, delay);
			};
		};

		// Create a debounced version of scrollToTop
		const debouncedScrollToTop = debounce(scrollToTop, 100); // Adjust the delay as needed
		const activateTab = (tabId) => {
			const tabs = document.querySelectorAll('.tab-content');
			tabs.forEach((tab) => tab.classList.remove('active'));

			const activeTab = document.getElementById(tabId);
			activeTabId = tabId; // Store the active tabId
			window.location.hash = tabId;

			if (activeTab) {
				activeTab.classList.add('active');
				setTimeout(() => {
					debouncedScrollToTop(activeTab);
				}, 250);
			}
		};

		// Handle hash change
		const handleHashChange = () => {
			if (!isCloseButtonClicked) {
				initializeTabFromHash();
			}
			isCloseButtonClicked = false; // Reset the flag after handling hash change
		};

		window.addEventListener('hashchange', handleHashChange);

		const hashLinks = document.querySelectorAll('a[href*="#"]');

		const handleHashLinkClick = (link) => {
			link.addEventListener('click', (e) => {
				e.preventDefault();
				e.stopPropagation(); // Add this line to stop event propagation
				const tabId = link.getAttribute('href').substr(1);
				if (tabId !== '' && allowedHashes.has(tabId)) {
					activateTab(tabId);
				}
			});
		};

		// Map tParamValue to corresponding hash value
		const tParamToHash = {
			1: 'telephone',
			2: 'offer',
			3: 'freetrial',
			4: 'quickorder',
			5: 'thank-you',
		};

		const initializeTabFromHash = () => {
			const hash = window.location.hash.substring(1);

			const currentURL = window.location.href;

			window.initUrl = hash && allowedHashes.has(hash) ? hash : 'telephone';

			if (!hash) {
				if (!window.location.href.includes('#')) {
					const urlParams = new URLSearchParams(currentURL.split('?')[1]);
					const tParamValue = urlParams.get('t');
					window.initUrl = tParamToHash[tParamValue] || 'telephone';
					activateTab(window.initUrl);
				}
			} else {
				activateTab(window.initUrl);
			}
		};

		initializeTabFromHash();

		hashLinks.forEach((link) => {
			// Check if the link has already been marked with an event listener flag
			if (!link.hasAttribute('data-event-listener')) {
				// If not, mark it, add the event listener, and mark it as having an event listener
				link.setAttribute('data-event-listener', 'true');
				handleHashLinkClick(link);
			}
		});

		const words = [
			'Ärzten',
			'Anwälten',
			'Immobilienmaklern',
			'Finanzberatern',
			'eCommerce',
			'Freiberuflern',
			'Selbstständigen',
			'Hotels',
			'IT-Systemhäusern',
			'Gesundheitsanbietern',
			'Fitnessstudios',
			'Physiotherapeuten',
			'Touristiken',
			'Agenturen',
			'Unternehmensberatungen',
			'Zahnärzten',
			'Hochschulen',
			'Weiterbildungsinstituten',
		];

		let part = '',
			i = 0,
			offset = 0,
			forwards = true,
			skipCount = 0,
			skipDelay = 15,
			speed = 70;

		const wordflick = () => {
			const typedWordsElement = document.querySelector('.typed-words');
			if (!typedWordsElement) {
				return;
			}
			setInterval(() => {
				if (forwards) {
					if (offset >= words[i].length) {
						skipCount++;
						if (skipCount === skipDelay) {
							forwards = false;
							skipCount = 0;
						}
					}
				} else if (offset === 0) {
					forwards = true;
					i = (i + 1) % words.length; // Use modulo to ensure i stays within bounds
				}

				part = words[i].substr(0, offset);
				if (skipCount === 0) {
					forwards ? offset++ : offset--;
				}

				typedWordsElement.textContent = part;
			}, speed);
		};

		setTimeout(wordflick, 800);

		const sliderElement = document.querySelector('.slider');
		if (!sliderElement) {
			return;
		}

		const slider = tns({
			container: '.slider',
			items: 1,
			slideBy: 'page',
			mouseDrag: true,
			swipeAngle: false,
			speed: 500,
			nav: false,
			loop: true,
			center: true,
			arrowKeys: true,
			lazyload: false,
			preventScrollOnTouch: 'force',
			prevButton: '.prev-button',
			nextButton: '.next-button',
		});
		function wrapSelectElements() {
			const inputElementBlocks = document.querySelectorAll('.input-element-block');

			inputElementBlocks.forEach((inputElementBlock) => {
				const selectElement = inputElementBlock.querySelector('select');

				if (selectElement) {
					const divElement = document.createElement('div');
					divElement.className = 'input-element-select';

					// Wrap the select element with the new div element
					selectElement.parentNode.insertBefore(divElement, selectElement);
					divElement.appendChild(selectElement);
				}
			});
		}

		wrapSelectElements();

		// callback form
		const instantCallbackRadio = document.getElementById('instant_callback-callback-instant');
		const dateTimeCallbackRadio = document.getElementById('instant_callback-callback-date-time');
		const instantCallbackDiv = document.querySelector('.callback-instant');
		const dateTimeCallbackDiv = document.querySelector('.callback-date-time');
		const callbackDateInput = document.querySelector('[name="callback_date"]');

		instantCallbackRadio.addEventListener('change', function () {
			// Check if the instantCallbackRadio is selected
			if (instantCallbackRadio.checked) {
				// Show instant callback div and hide date-time callback div
				instantCallbackDiv.classList.remove('u-hidden');
				dateTimeCallbackDiv.classList.add('u-hidden');
				callbackDateInput.removeAttribute('required');
			}
		});

		dateTimeCallbackRadio.addEventListener('change', function () {
			// Check if the dateTimeCallbackRadio is selected
			if (dateTimeCallbackRadio.checked) {
				// Show date-time callback div and hide instant callback div
				instantCallbackDiv.classList.add('u-hidden');
				dateTimeCallbackDiv.classList.remove('u-hidden');
				callbackDateInput.setAttribute('required', 'required');
			}
		});

		// popup
		const overlay = document.getElementById('overlay');
		window.showPopup = (selector) => {
			const popup = document.querySelector(selector);

			if (popup) {
				const popupBox = popup.querySelector('.popup-box');
				popupBox.style.height =
					selector === '#offer-popup' ? 'auto' : `${Math.min(window.innerHeight * 0.75, 600)}px`;

				overlay.classList.add('is-open');
				popup.classList.add('is-open');

				const closePopup = () => {
					popup.classList.add('fade-out');
					overlay.removeEventListener('click', closePopup);
					popup.querySelector('.close').removeEventListener('click', closePopup);
					isCloseButtonClicked = true;
					setTimeout(() => {
						overlay.classList.remove('is-open');
						popup.classList.remove('is-open', 'fade-out'); // Remove is-open and fade-out classes after transition
					}, 500);
				};

				overlay.addEventListener('click', closePopup);
				popup.querySelector('.close').addEventListener('click', closePopup);

				return true;
			}

			return false;
		};

		const handlePopupLinkClick = (e) => {
			e.stopPropagation();
			e.preventDefault();
			const popupData = e.target.dataset.selector;
			if (popupData) {
				isCloseButtonClicked = false; // Reset the flag when a popup link is clicked
				return !window.showPopup(popupData);
			}
		};

		document.querySelectorAll('.popup-link, .popup-link a').forEach((link) => {
			link.addEventListener('click', handlePopupLinkClick);
		});

		// Add event listener for the close button inside offer-popup
		document.getElementById('btn-offer-popup').addEventListener('click', (e) => {
			e.preventDefault();

			// Close the offer-popup and navigate to the #offer page
			const offerPopup = document.querySelector('#offer-popup');
			if (offerPopup) {
				offerPopup.classList.add('fade-out');
				isCloseButtonClicked = true;
				setTimeout(() => {
					overlay.classList.remove('is-open');
					offerPopup.classList.remove('is-open', 'fade-out');
					window.location.hash = '#offer';
					const offerElement = document.querySelector('#offer');

					if (offerElement) {
						window.location.hash = '#offer';
						debouncedScrollToTop('#offer');
					} else {
						console.error("Element with selector '#offer' not found");
					}
				}, 250);
			} else {
				console.error("Element with selector '#offer-popup' not found");
			}
		});

		const handleFormLinkClick = (e, formClassName) => {
			e.stopPropagation();
			e.preventDefault();

			document.querySelectorAll('.popup-form-menu .menu-item, .popup-form-wrapper').forEach((el) => {
				el.classList.remove('menu-selected', 'popup-form-selected', 'contact-hover-wrapper');
			});

			e.target.parentElement.classList.add('menu-selected');
			document.querySelector(`.${formClassName}-form-wrapper`).classList.add('popup-form-selected');
		};

		document.querySelector('.link-contact').addEventListener('click', (e) => {
			handleFormLinkClick(e, 'contact');
		});

		document.querySelector('.link-short-info').addEventListener('click', (e) => {
			handleFormLinkClick(e, 'shortinfo');
		});

		document.querySelector('.link-callback').addEventListener('click', (e) => {
			handleFormLinkClick(e, 'callback');
		});

		const handleContactHover = () => {
			document.querySelector('.popup-form-selected').classList.toggle('contact-hover-wrapper');
		};

		document.querySelector('.link-contact').addEventListener('mouseenter', handleContactHover);
		document.querySelector('.link-contact').addEventListener('mouseleave', handleContactHover);

		// show-hide company info

		const handleCompanyInfoClick = function (e) {
			e.stopPropagation();
			e.preventDefault();

			const companyInfo = document.getElementById('company-info');
			companyInfo.classList.toggle('u-hidden');

			// Scroll to the company-info element if it's visible
			if (companyInfo.style.display !== 'none') {
				companyInfo.scrollIntoView({
					behavior: 'smooth',
					block: 'start',
				});
			}
		};

		document.querySelectorAll('.link-company-info, .btn-close-company-info').forEach(function (element) {
			element.addEventListener('click', handleCompanyInfoClick);
		});

		// event tracking
		function trackButtonClick(selector, options) {
			var button = document.querySelector(selector);
			if (button && typeof gtag === 'function') {
				button.addEventListener('click', function (e) {
					e.stopPropagation();
					e.preventDefault();
					gtag('event', 'click', options);
				});
			}
		}
		trackButtonClick('#btn-freetrial', {
			button: 'offer_rv5_start_hero',
			action: 'start',
		});

		trackButtonClick('#btn-offer', {
			button: 'offer_rv5_start_hero',
			action: 'start',
		});

		trackButtonClick('#btn-offer-industries', {
			button: 'offer_rv5_start_industries',
			action: 'start',
		});

		trackButtonClick('#btn-offer-request', {
			button: 'offer_rv5_start_request',
			action: 'start',
		});

		trackButtonClick('#btn-offer-popup', {
			button: 'offer_rv5_start_popup',
			action: 'start',
		});

		trackButtonClick('#btn-answer-no', {
			button: 'question_rv5',
			question_number: '1',
			answer: 'no',
		});

		trackButtonClick('#btn-answer-yes', {
			button: 'question_rv5',
			question_number: '1',
			answer: 'yes',
		});
	});
};
